
document.addEventListener("DOMContentLoaded",function(){

const quizMap={
focus:'/collections/enfoque',
memoria:'/collections/memoria',
energia:'/collections/energia',
sueno:'/collections/sueno'
};

document.querySelectorAll("[data-nm-quiz]").forEach(btn=>{
 btn.addEventListener("click",()=>{
  const key=btn.getAttribute("data-nm-quiz");
  if(quizMap[key]) window.location.href=quizMap[key];
 });
});

});

/* ============================================================
   NM MEJORAS 2025 — AJAX Quick-Add + Collapsible Description
   ============================================================ */
(function(){
  'use strict';

  /* --- AJAX Quick-Add al carrito --- */
  function initQuickAdd(){
    document.querySelectorAll('.nm-quick-add-form').forEach(function(form){
      if(form.dataset.nmAjaxBound) return;
      form.dataset.nmAjaxBound = '1';
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn   = form.querySelector('.nm-quick-add');
        var txt   = form.querySelector('.nm-quick-add__text');
        var load  = form.querySelector('.nm-quick-add__loading');
        var done  = form.querySelector('.nm-quick-add__done');
        var varId = form.dataset.variantId || form.querySelector('[name="id"]').value;
        if(!varId) return;

        btn.classList.add('is-loading');
        if(txt)  txt.style.display='none';
        if(load) load.style.display='';

        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify({id: parseInt(varId), quantity:1})
        })
        .then(function(r){ return r.json(); })
        .then(function(data){
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          if(load) load.style.display='none';
          if(done) done.style.display='';

          /* Abrir cart drawer si existe */
          if(typeof NMCartDrawer !== 'undefined' && NMCartDrawer.open){
            NMCartDrawer.open();
          } else {
            /* Fallback: disparar evento para cualquier drawer del tema */
            document.dispatchEvent(new CustomEvent('cart:open'));
            var drawerTrigger = document.querySelector('[data-cart-drawer-trigger],[data-nm-cart-open],.js-cart-drawer-toggle');
            if(drawerTrigger) drawerTrigger.click();
          }

          /* Actualizar contador de carrito */
          fetch('/cart.js')
            .then(function(r){ return r.json(); })
            .then(function(cart){
              document.querySelectorAll('.nm-cart-count,[data-cart-count],.cart-count').forEach(function(el){
                el.textContent = cart.item_count;
              });
            }).catch(function(){});

          /* Restaurar botón tras 2.5s */
          setTimeout(function(){
            btn.classList.remove('is-done');
            if(txt)  txt.style.display='';
            if(done) done.style.display='none';
          }, 2500);
        })
        .catch(function(){
          btn.classList.remove('is-loading');
          if(load) load.style.display='none';
          if(txt)  txt.style.display='';
          /* Fallback: submit normal */
          form.submit();
        });
      });
    });
  }

  /* --- Descripción de colección colapsable --- */
  function initCollectionDesc(){
    document.querySelectorAll('.nm-col-intro').forEach(function(intro){
      if(intro.dataset.nmCollapseBound) return;
      intro.dataset.nmCollapseBound = '1';

      /* Solo aplica si el texto es más largo de 3 líneas */
      if(intro.scrollHeight <= 70) return;

      /* Envolver contenido */
      var wrap = document.createElement('div');
      wrap.className = 'nm-col-intro-wrap';
      var body = document.createElement('div');
      body.className = 'nm-col-intro-body';
      var fade = document.createElement('div');
      fade.className = 'nm-col-intro-fade';
      var toggle = document.createElement('button');
      toggle.className = 'nm-col-intro-toggle';
      toggle.textContent = 'Leer mas +';
      toggle.type = 'button';

      intro.parentNode.insertBefore(wrap, intro);
      body.appendChild(intro);
      wrap.appendChild(body);
      wrap.appendChild(fade);
      wrap.appendChild(toggle);

      toggle.addEventListener('click', function(){
        var open = body.classList.toggle('is-open');
        toggle.textContent = open ? 'Leer menos -' : 'Leer mas +';
      });
    });
  }

  /* Inicializar en DOMContentLoaded y re-inicializar si hay navegacion AJAX */
  function init(){
    initQuickAdd();
    initCollectionDesc();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-bind si se carga contenido dinamico (filtros AJAX, paginacion) */
  var obs = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      if(m.addedNodes.length) initQuickAdd();
    });
  });
  obs.observe(document.body || document.documentElement, {childList:true, subtree:true});

})();
